import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';

import { TranslationParameters } from 'models';
import { ProgressDialogComponent } from '../components/progress-dialog/progress-dialog.component';

/** Service for injecting indeterminate progress dialog. */
@Injectable({
  providedIn: 'root',
})
export class ProgressDialogService {
  constructor(private dialogService: MatDialog) {}
  /**
   * Open the progress dialog.
   *
   * @param message Message to display in progress dialog.
   * @returns A dialog reference for the progress dialog. This should be used to close the dialog when necessary.
   */
  openProgressDialog(message: string, params?: TranslationParameters) {
    const data: ProgressDialogData = {
      message,
      params,
    };
    return this.dialogService.open(ProgressDialogComponent, {
      data,
      width: '400px',
      disableClose: true,
    });
  }
}
/**
 * Interface to define progress dialog data.
 */
export interface ProgressDialogData {
  /** Message to pass to the body of dialog. */
  message: string;
  /** Optional translation parameters. */
  params?: TranslationParameters;
}
